import React, { type FC } from 'react'

import {
  TEXT_VARIANT_BOLD_LIGHT,
  TEXT_VARIANT_LIGHT,
  Text,
} from 'mailup-web-components'

import type { FindReplaceMode } from 'Pages/RecipientsList/model'

import { makePreviewRegExp } from 'Pages/RecipientsList/helpers'

interface DecoratedTextProps {
  content: string
  findText: string
  findType: FindReplaceMode
  findCaseSensitive: boolean
}

const DecoratedText: FC<DecoratedTextProps> = ({
  content,
  findText,
  findType,
  findCaseSensitive,
}) => {
  const re = makePreviewRegExp(findText, findType, findCaseSensitive)

  if (re !== undefined) {
    const tokens = content.split(re)

    return (
      <Text variant={TEXT_VARIANT_LIGHT}>
        {tokens.map((t, i) => (
          <React.Fragment key={i}>
            {i > 0 && (
              <Text
                htmlElement="u"
                variant={TEXT_VARIANT_BOLD_LIGHT}
                overflowWrap="anywhere"
              >
                {findText}
              </Text>
            )}
            <span>{t}</span>
          </React.Fragment>
        ))}
      </Text>
    )
  }

  return (
    <Text variant={TEXT_VARIANT_LIGHT} overflowWrap="anywhere">
      {content}
    </Text>
  )
}

export default DecoratedText
